var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 24.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7142 27.3334C33.1633 27.3334 34.3379 28.508 34.3379 29.9571V30.6284C34.3379 31.6718 33.9651 32.6807 33.2867 33.4733C31.4557 35.6124 28.6706 36.668 25.0011 36.668C21.3309 36.668 18.5472 35.6121 16.7199 33.4721C16.0435 32.68 15.6719 31.6726 15.6719 30.631V29.9571C15.6719 28.508 16.8465 27.3334 18.2956 27.3334H31.7142ZM31.7142 29.0834H18.2956C17.813 29.0834 17.4219 29.4746 17.4219 29.9571V30.631C17.4219 31.256 17.6448 31.8604 18.0507 32.3356C19.5129 34.0479 21.8064 34.918 25.0011 34.918C28.1958 34.918 30.4913 34.0479 31.9571 32.3354C32.3643 31.8597 32.5879 31.2543 32.5879 30.6284V29.9571C32.5879 29.4746 32.1968 29.0834 31.7142 29.0834ZM25.0011 13.3389C28.2227 13.3389 30.8344 15.9505 30.8344 19.1722C30.8344 22.3939 28.2227 25.0056 25.0011 25.0056C21.7794 25.0056 19.1677 22.3939 19.1677 19.1722C19.1677 15.9505 21.7794 13.3389 25.0011 13.3389ZM25.0011 15.0889C22.7459 15.0889 20.9177 16.917 20.9177 19.1722C20.9177 21.4274 22.7459 23.2556 25.0011 23.2556C27.2563 23.2556 29.0844 21.4274 29.0844 19.1722C29.0844 16.917 27.2563 15.0889 25.0011 15.0889Z",
    fill: "#7D7D7D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 24.5,
    stroke: "#FAFAFA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.e96fbd77f99cb041ca59668a900cfb77.svg";
export { ForwardRef as ReactComponent };